import { Modal } from "@mui/material";
import Image from "next/image";
import GoogleTranslationComponent from "../googleTranslate/GoogleTranslationComponent";
import { useTranslation } from "@/app/i18n/client";
import cancelacionesBackground from "@/assets/images/decorators/cancelaciones-background.webp";
import Close from "@/assets/images/icons/close.svg";
import HexagonButton from "@/common/customElements/HexagonButton";
import { AbsoluteDiv } from "@/common/divs";
import { AlmostBoldText, LightText, SemiBoldText } from "@/common/texts";
import { ActivityDetailVm } from "@/model";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const ModalCancelaciones: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  detail_info: ActivityDetailVm | undefined;
}> = ({ open, setOpen, detail_info }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="centerModal tyc-modal" style={{ overflow: "hidden" }}>
        <Image
          src={cancelacionesBackground}
          alt="background"
          width={555}
          height={1000}
          className="image-tyc"
          style={{
            height: "auto",
            width: "100%",
            objectFit: "cover",
            position: "fixed",
            zIndex: "-1",
          }}
        />

        <section className="modal-section-style" style={{ marginTop: "20px" }}>
          <AlmostBoldText fontSize="24px" style={{ justifyContent: "center" }}>
            <GoogleTranslationComponent text="¿Qué incluye y qué no?" />
          </AlmostBoldText>
          <AbsoluteDiv right="24px" top="24px">
            <HexagonButton
              onClick={() => setOpen(false)}
              width="32px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
            >
              <Image
                alt="close"
                width="16"
                height="16"
                src={Close.src}
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "27%",
                }}
              />
            </HexagonButton>
          </AbsoluteDiv>
        </section>
        {detail_info && (
          <section
            className="mini-modal-section"
            style={{ marginTop: "20px", maxHeight: "70vh", overflowY: "auto" }}
          >
            <>
              <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
                {t("activity.details.includes")}
              </SemiBoldText>
              {detail_info.include ?
                detail_info.include.map((option, index) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={option.description ?? ""}
                    />
                  </LightText>
                ))
              : <LightText style={{ marginTop: "8px" }}>
                  • {t("activity.no_details")}
                </LightText>
              }
              <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
                {t("activity.details.restrictions")}
              </SemiBoldText>
              {detail_info.restrictions ?
                detail_info.restrictions.map((option, index) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={option.description ?? ""}
                    />
                  </LightText>
                ))
              : <LightText style={{ marginTop: "8px" }}>
                  • {t("activity.no_details")}
                </LightText>
              }
              <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
                {t("activity.details.recommendations")}
              </SemiBoldText>
              {detail_info.recommendations ?
                detail_info.recommendations.map((option, index) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={option.description ?? ""}
                    />
                  </LightText>
                ))
              : <LightText style={{ marginTop: "8px" }}>
                  • {t("activity.no_details")}
                </LightText>
              }
              <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
                {t("activity.details.not_includes")}
              </SemiBoldText>
              {detail_info.exclude ?
                detail_info.exclude.map((option, index) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={option.description ?? ""}
                    />
                  </LightText>
                ))
              : <LightText style={{ marginTop: "8px" }}>
                  • {t("activity.no_details")}
                </LightText>
              }
              <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
                {t("activity.details.languages")}
              </SemiBoldText>
              {detail_info.language ?
                detail_info.language.map((option, index) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    • <GoogleTranslationComponent text={option.name ?? ""} />
                  </LightText>
                ))
              : <LightText style={{ marginTop: "8px" }}>
                  • {t("activity.no_details")}
                </LightText>
              }
              <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
                {t("activity.details.tags")}
              </SemiBoldText>
              {detail_info.tags &&
                detail_info.tags.map((option, index) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    • <GoogleTranslationComponent text={option.name ?? ""} />
                  </LightText>
                ))}
            </>
          </section>
        )}
      </div>
    </Modal>
  );
};

export default ModalCancelaciones;
